export default "__VITE_ASSET__DN9T3W_n__"